import { Tabs, Tab } from "@heroui/react";
import { useEffect, useState } from "react";

export default function DefaultTabs({ tabs = [], defaultTab }) {
  const [selected, setSelected] = useState(defaultTab);

  useEffect(() => {
    setSelected(defaultTab);
  }, [defaultTab]);

  return (
    <div className="flex w-full flex-col page-wrapper px-6 py-4 bg-white rounded-global h-full">
      <div className="pt-3 h-full">
        <Tabs
          className="pb-1"
          aria-label="Options"
          color="secondary"
          variant="bordered"
          selectedKey={selected}
          onSelectionChange={setSelected}
        >
          {tabs.map((tab) => (
            <Tab
              key={tab.key}
              title={
                <div className="flex items-center space-x-2 text-black">
                  {tab.icon}
                  <span>{tab.title}</span>
                </div>
              }
            >
              <div className="m-0 border border-gray-100 p-0 rounded-2xl h-full">
                {tab.component}
              </div>
            </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
